import { TransactionType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const transactionTypeName: { [key in TransactionType]: TKeyType } = {
  [TransactionType.TRANSFER_IN]: 'transactionType.transferIn',
  [TransactionType.TRANSFER_OUT]: 'transactionType.transferOut'
}

export default transactionTypeName
